import { type Texture } from '@babylonjs/core/Materials/Textures/texture';
import { type ITransformRT2, type IVector2 } from '@seddi/math-v2';

/**
 * Applies repeat scale to texture.
 * @param texture - Texture.
 * @param repeat - Repeat scale.
 */
export const textureSetScale = (texture: Texture, scale: IVector2) => {
  texture.uScale = scale.x;
  texture.vScale = scale.y;
};

/**
 * Applies repeat size to texture.
 * @param texture - Texture.
 * @param repeat - Repeat size.
 */
export const textureSetSize = (texture: Texture, size: IVector2) => {
  texture.uScale = 1.0 / size.x;
  texture.vScale = 1.0 / size.y;
};

/**
 * Applies RT transform to texture.
 * @param texture - Texture.
 * @param transform - RT transform.
 */
export const textureSetTransform = (texture: Texture, transform: ITransformRT2) => {
  texture.homogeneousRotationInUVTransform = true;
  texture.uOffset = -transform.translation.x * texture.uScale;
  texture.vOffset = -transform.translation.y * texture.vScale;
  texture.uRotationCenter = transform.translation.x;
  texture.vRotationCenter = transform.translation.y;
  texture.wAng = -transform.rotation;
};
